import { useState } from "react";
import config from "../configurations/config";
import "./SamlOneWayRegistration.css";

const SamlRegistrationForm = () => {
  const [inputValue, setInputValue] = useState("");
  const [iframeUrl, setIframeUrl] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    setError(null);
    setIframeUrl(null);
    setLoading(true);

    try {
      const subDomain = config.apiGateway.URL.match(/\.(.*?)\-/)[1];
      const registrationURL =
        subDomain === "dev" || subDomain === "stage"
          ? `https://passport-api.${subDomain}-open-exchange.net/attendee/saml-one-way-register`
          : `https://passport-api.open-exchange.net/attendee/saml-one-way-register`;
      const response = await fetch(registrationURL, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams({ SAMLResponse: inputValue }).toString(),
      });

      if (response.status === 200) {
        const redirectUrl = response.url;

        if (!redirectUrl) {
          throw new Error(
            "200 response received but no redirect URL available."
          );
        }

        setIframeUrl(redirectUrl);
        return;
      }

      if (!response.ok) {
        const errData = await response.json().catch(() => null);
        throw new Error(
          errData?.message || `Request failed with status ${response.status}`
        );
      }

      const data = await response.json().catch(() => null);

      if (data?.redirectUrl) {
        setIframeUrl(data.redirectUrl);
      } else {
        throw new Error("Success response received but no redirectUrl found.");
      }
    } catch (err) {
      setError(err.message || "Network error");
    }

    setLoading(false);
  };

  return (
    <div className="registration-container">
      {!iframeUrl && (
        <div className="registration-box">
          <h3 className="form-title">SAML Registration Form</h3>

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <span className="label-text">SAML Response Key</span>

              <input
                type="text"
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
                className="input-box"
              />
            </div>

            <div className="submit-wrapper">
              <button type="submit" disabled={loading} className="submit-btn">
                {loading ? "Submitting..." : "Submit"}
              </button>
            </div>
          </form>

          {error && (
            <div className="error-box">
              <strong>Error:</strong> {error}
            </div>
          )}
        </div>
      )}

      {iframeUrl && (
        <iframe
          title="redirect-frame"
          src={iframeUrl}
          allow="autoplay; fullscreen; encrypted-media"
          className="result-iframe"
        />
      )}
    </div>
  );
};

export default SamlRegistrationForm;
